import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=18345309&scoped=true&"
import script from "./TransactionDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetail.vue?vue&type=style&index=0&id=18345309&lang=scss&scoped=true&"
import style1 from "./TransactionDetail.vue?vue&type=style&index=1&id=18345309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18345309",
  null
  
)

export default component.exports